import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ActiveProduct, ActiveProductsState } from '../../types/activeProduct';
import { fetchActiveProducts } from './actions';

const initialState: ActiveProductsState = {
  products: [],
  loading: false,
  error: null,
};

const activeProductsSlice = createSlice({
  name: 'activeProducts',
  initialState,
  reducers: {
    clearActiveProducts: (state) => {
      state.products = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActiveProducts.fulfilled, (state, action: PayloadAction<ActiveProduct[]>) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(fetchActiveProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) ?? 'Failed to fetch active products';
      });
  },
});

export const { clearActiveProducts } = activeProductsSlice.actions;
export const activeProductsReducer = activeProductsSlice.reducer;
